import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function Banner(props) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Data Analytics">
                <h1>Big Data Analytics Services</h1>
              </div>
              <p className="main_para">
                Leverage big data analytics and business intelligence tools to
                extract actionable insights. Businesses can make data-driven
                decisions and gain a competitive advantage in their industries.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banner_content_txt">
              <p>
                TekRevol’s big data analytics services are designed for
                enterprise organizations. We leverage modern tools and
                techniques to turn your raw data into useful insights – helping
                you drive valuable conclusions.{" "}
              </p>
              <ul>
                <li>Data Integration</li>
                <li>Data Monetization</li>
                <li>Data Insights</li>
                <li>Data Transformation</li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
